module.exports = __webpack_public_path__ + "img/icon-our-networks.c781c3af.png";